import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { TESTI } from "@/constants/testIds";

const QUOTES = [
  {
    q: "JDTECH felt like an in-house team from week one. They ship faster than agencies and care more than most full-timers.",
    n: "Ananya Sharma",
    r: "VP Product, FinSwift",
  },
  {
    q: "Their AI work isn't a demo — it's in production, used by 40k users daily. That alone makes them rare.",
    n: "Marcus Lee",
    r: "CTO, OrbitAI",
  },
  {
    q: "Pixel-perfect, performance obsessed, and somehow always under budget. I'd hire them again in a heartbeat.",
    n: "Rhea Kapoor",
    r: "Founder, Marigold",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid={TESTI.section}
      className="relative py-20 md:py-40 border-t border-white/5"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 md:px-10">
        <div className="mb-12 md:mb-20">
          <p className="text-[10px] md:text-xs font-bold uppercase tracking-[0.3em] text-[#0A84FF] mb-3 md:mb-4">
            Voices
          </p>
          <h2 className="font-display text-[10vw] sm:text-5xl lg:text-7xl font-black tracking-[-0.03em] leading-[1.02] text-grad max-w-3xl">
            Trusted by founders<br />and CTOs.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {QUOTES.map((t, i) => (
            <motion.figure
              key={t.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="glass rounded-2xl md:rounded-3xl p-6 sm:p-8 md:p-10 flex flex-col h-full relative overflow-hidden"
            >
              <Quote className="absolute -top-2 -right-2 text-white/5" size={120} strokeWidth={1} />
              <blockquote className="relative font-display text-base sm:text-lg md:text-xl leading-snug tracking-tight text-white/90">
                &ldquo;{t.q}&rdquo;
              </blockquote>
              <figcaption className="relative mt-6 md:mt-8 pt-5 md:pt-6 border-t border-white/10">
                <div className="text-sm font-semibold text-white">{t.n}</div>
                <div className="text-xs text-[#a1a1a6] mt-0.5">{t.r}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
